import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { CustomPageCreateEditProvider } from './context/custom-page-create-edit-context';
import { CustomPageCreateEditComponent } from './custom-page-create-edit-component';

export function CustomPageCreateEditFactory() {
    return (
        <BaseLayoutFactory>
            <CustomPageCreateEditProvider>
                <CustomPageCreateEditComponent />
            </CustomPageCreateEditProvider>
        </BaseLayoutFactory>
    );
}
